import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'select',
        name: 'fault_result',
        title: 'Sonuç',
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            track: 'id',
        },
        modal: ['fault_support_result_id'],
        data: ['fault_support_result_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'stockStatus',
        title: 'Cihaz Stok Durumu',
        default: 0,
        rules: {required: true},
        options: {
            type: 'locale',
            data: [
                {text: 'Müşteriye Gönderildi', value: 0},
                {text: 'Stoğa Alındı', value: 1},
            ],
        },
        modal: ['is_put_in_warehouse'],
        data: ['is_put_in_warehouse'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'warehouse',
        connectField: 'stockStatus',
        connectFieldValue: [1],
        title: 'Depo',
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            track: 'id',
        },
        modal: ['warehouse_id'],
        data: ['warehouse_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'file',
        name: 'image',
        title: 'Resim',
        placeHolder: 'Destek ile ilgili resim ekle veya sürükle',
        rules: {required: false},
        modal: ['image'],
        data: ['image'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'desc',
        title: 'Açıklama',
        rules: {required: false},
        modal: ['description'],
        data: ['description'],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/ERP/Stock/forms/faultClose.js